export default __webpack_public_path__ + "3e1e23ea2943c0e3b5980aee46168961.png";